import React, { Component } from 'react'
import { connect } from 'react-redux'
import { requestRegister, getUserByEmail, requestLogin, loginWithGoogleToken } from '@actions/user'
import LoginForm from '../LoginForm'
import RegisterForm from '../RegisterForm'
import { Swap, SwapItem } from '../Swap'
import { openGooglePopup } from '../../utils/googlePopup'
import { withRouter } from '../../utils/withRouter'
import './index.css'

class Identification extends Component {
  constructor(props) {
    super(props)
    this.state = {
      swap: '',
    }
  }

  _swapTo(swap) {
    this.setState({ swap })
  }

  _getButtons() {
    if (!this.state.swap) {
      return (
        <div>
          <h3 className="identification__title">Identificação</h3>
          <h4 className="identification__subtitle">Faça o login ou cadastre-se para continuar</h4>
          <div>
          <button
            id="identification-already-registered-button"
            className="identification__button--login"
            onClick={() => {
              window.ga('send', {
                hitType: 'event',
                eventCategory: 'compra',
                eventAction: 'click',
                eventLabel: 'usuario_existente_4',
              })

              this._swapTo('login')
            }}
          >
            Entrar com email e senha
          </button>
            
          </div>
          <div>
          <button
            className="identification__button--register"
            onClick={() => {
              window.ga('send', {
                hitType: 'event',
                eventCategory: 'compra',
                eventAction: 'click',
                eventLabel: 'novo_usuario_4',
              })

              this._swapTo('register')
            }}
          >
            Não tenho cadastro
          </button>
          </div>
          <div className="identification__divider">
            <span>ou</span>
          </div>
          <button
            type="button"
            className="identification__google-button"
            onClick={() => {
              openGooglePopup(
                (token, user) => {
                  console.log('Identification: token recebido, iniciando login')
                  this.props.loginWithGoogleToken(token, user).then(() => {
                    console.log('Identification: login concluído, navegando')
                    this.props.navigate('/steps/atualizacao')
                  })
                },
                (err) => console.error('Erro Google login:', err)
              )
            }}
          >
            <svg width="22" height="22" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
              <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
              <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05"/>
              <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
            </svg>
            Entrar com Google
          </button>
        </div>
      )
    } else {
      return null
    }
  }

  render() {
    let { submitRegisterForm, getUserByEmail, user, requestLogin } = this.props

    return (
      <div className="identification">
        {this._getButtons()}

        {this.state.swap ? (
          <Swap active={this.state.swap}>
            <SwapItem name="login">
              <div className="identification__login">
                <LoginForm swapTo={swap => this._swapTo(swap)} title="Falta pouco. Faça login para continuar" />
              </div>
            </SwapItem>
            <SwapItem name="register">
              <div className="identification__login">
                <RegisterForm
                  swapTo={swap => this._swapTo(swap)}
                  submitRegisterForm={submitRegisterForm}
                  getUserByEmail={getUserByEmail}
                  requestLogin={requestLogin}
                  user={user}
                  title="Cadastro"
                  subtitle="Falta pouco. Faça seu cadastro para continuar."
                />
              </div>
            </SwapItem>
          </Swap>
        ) : null}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  user: state.user,
})

const mapDispatchToProps = dispatch => ({
  submitRegisterForm: (user, isDefault) => {
    return new Promise((resolve, reject) => {
      let result = dispatch(requestRegister(user, isDefault))
      resolve(result)
    })
  },
  getUserByEmail: email => dispatch(getUserByEmail(email)),
  requestLogin: (user, path) => dispatch(requestLogin(user, path)),
  loginWithGoogleToken: (token, user) => dispatch(loginWithGoogleToken(token, user)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Identification))

